import { APIRoute } from '@/modules/utils'

export type Body = {
  email: string
}
export type Response = {
  success?: boolean
}

export const Route: APIRoute = {
  method: 'POST',
  path: '/v2/account/change-password',
}
